//from Node
require('js.cookie');
require('bootstrap-datepicker');

//from local
require('./plugins/confetti');
require('./base');
require('./cookie-banner');
